import { GET, POST, PUT } from "./utility";

const GATEWAY_URL = "/auth";
const PRIVATE_BASE_URL = GATEWAY_URL + "/api/scuoladigitaleliguria/osservatorio/v1";

// Modulo common
export const USER_INFO_API = {
  method: GET,
  baseUrl: GATEWAY_URL,
  apiUrl: "/userInfo",
};

export const USER_AUTHENTICATED_API = {
  method: GET,
  baseUrl: GATEWAY_URL,
  apiUrl: "/isAuthenticated",
};

export const SESSION_INFO_API = {
  method: GET,
  baseUrl: GATEWAY_URL,
  apiUrl: "/sessionInfo",
};

// Modulo osservatorio
export const PROFILO_API = {
  method: GET,
  baseUrl: PRIVATE_BASE_URL,
  apiUrl: "/getProfilo",
};

export const ISTITUTI_SCOLASTICI_API = {
  method: GET,
  baseUrl: PRIVATE_BASE_URL,
  apiUrl: "/istitutiScolastici",
};

export const INCARICHI_API = {
  method: GET,
  baseUrl: PRIVATE_BASE_URL,
  apiUrl: "/incarichi",
};

export const INSERISCI_PROFILO_API = {
  method: POST,
  baseUrl: PRIVATE_BASE_URL,
  apiUrl: "/setProfilo",
};

export const AGGIORNA_PROFILO_API = {
  method: PUT,
  baseUrl: PRIVATE_BASE_URL,
  apiUrl: "/putProfilo",
};

export const AGGIORNA_RUOLO_ISTITUTO_API = {
  method: PUT,
  baseUrl: PRIVATE_BASE_URL,
  apiUrl: "/putRuoloIstituto",
};
